import React from "react";
import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import "./App.css";
import Dashboard from "./pages/dashboard/page/Dashboard";
import Login from "./pages/login/page/Login";
import TunasSideBar from "./components/sidebar/TunasSideBar";
import DoctorList from "./pages/doctor_list/page/doctorList";
import DoctorSpecialist from "./pages/doctor_spesialist/page/doctorSpecialist";
import DoctorTreatment from "./pages/doctor_treatment/page/doctorTreatment";
import PatientList from "./pages/patient_list/page/patientList";
import SupplierList from "./pages/supplier_list/page/supplierList";
import PartnerList from "./pages/partner/page/partnerList";
import StaffList from "./pages/staff/page/staffList";
import ProductUnit from "./pages/product_unit/page/productUnit";
import ProductCategory from "./pages/product_category/page/productCategory";
import BankList from "./pages/bank/page/bankList";
import ProductList from "./pages/product/page/productList";
import ProductInvoice from "./pages/product_invoice/page/productInvoice";
import AddProductInvoice from "./pages/product_invoice/page/addProductInvoice";
import EditProductInvoice from "./pages/product_invoice/page/editProductInvoice";
import OtcTransaction from "./pages/transaction/otc_transaction/page/otcTransaction";
import DoctorTreatmentTransaction from "./pages/transaction/doctor_treatment_transaction/page/doctorTreatmentTransaction";
import PharmacySales from "./pages/sales/page/pharmacy_sales/pharmacySales";
import ClinicSales from "./pages/sales/page/clinic-sales/clinicSales";
import UnpaidInvoice from "./pages/unpaid_invoice/page/unpaidInvoice";
import ExpiredProductInvoice from "./pages/expired_product_invoice/page/expiredProductInvoice";
import PharmacySalesYearly from "./pages/sales/page/pharmacy_sales/pharmacySalesYearly";
import ClinicSalesYearly from "./pages/sales/page/clinic-sales/clinicSalesYearly";
import PharmacySalesMonthly from "./pages/sales/page/pharmacy_sales/pharmacySalesMonthly";
import ClinicSalesMonthly from "./pages/sales/page/clinic-sales/clinicSalesMonthly";
import MedicalTreatmentRecord from "./pages/medical_treatment_record/page/medicalTreatmentRecord";
import ProfitReport from "./pages/profit_report/page/profitReport";
import PharmacyDistribution from "./pages/pharmacy_distribution/page/pharmacyDistribution";
import PartnerOtcTransaction from "./pages/transaction/partner_otc_transaction/page/partnerOtcTransaction";
import ClinicPartnerDaily from "./pages/sales/page/clinic-partner-sales/page/daily/clinicPartnerDaily";
import ClinicPartnerMonthly from "./pages/sales/page/clinic-partner-sales/page/monthly/clinicPartnerMonthly";
import ClinicPartnerYearly from "./pages/sales/page/clinic-partner-sales/page/yearly/clinicPartnerYearly";
import PatientRecord from "./pages/patient_record/page/patientRecord";
import ReturList from "./pages/retur/page/returList";
import ClinicPartnerRanged from "./pages/sales/page/clinic-partner-sales/page/ranged/clinicPartnerRanged";
import ProductDetail from "./pages/product/page/productDetail";

function ScrollToTop() {
  const { pathname } = useLocation()
  React.useLayoutEffect(() => {
    window.scrollTo({ left: 0, top: 0, behavior: "instant" })
  }, [pathname])
  return null
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route
          path="/dashboard"
          element={
            <WithSidebar component={<Dashboard />} path={"/dashboard"} />
          }
        />
        <Route
          path="/daftar-dokter"
          element={
            <WithSidebar component={<DoctorList />} path={"/daftar-dokter"} />
          }
        />
        <Route
          path="/poli"
          element={
            <WithSidebar component={<DoctorSpecialist />} path={"/poli"} />
          }
        />
        <Route
          path="/tindakan"
          element={
            <WithSidebar component={<DoctorTreatment />} path={"/tindakan"} />
          }
        />
        <Route
          path="/daftar-pasien"
          element={
            <WithSidebar component={<PatientList />} path={"/daftar-pasien"} />
          }
        />
        <Route
          path="/daftar-produk"
          element={
            <WithSidebar component={<ProductList />} path={"/daftar-produk"} />
          }
        />
        <Route
          path="/daftar-produk/:productId"
          element={<ProductDetail />}
        />
        <Route
          path="/produk-kategori"
          element={
            <WithSidebar
              component={<ProductCategory />}
              path={"/produk-kategori"}
            />
          }
        />
        <Route
          path="/produk-unit"
          element={
            <WithSidebar component={<ProductUnit />} path={"/produk-unit"} />
          }
        />
        <Route
          path="/produk-invoice"
          element={
            <WithSidebar
              component={<ProductInvoice />}
              path={"/produk-invoice"}
            />
          }
        />
        <Route path="/add-produk-invoice" element={<AddProductInvoice />} />
        <Route path="/edit-produk-invoice" element={<EditProductInvoice />} />
        <Route
          path="/daftar-supplier"
          element={
            <WithSidebar
              component={<SupplierList />}
              path={"/daftar-supplier"}
            />
          }
        />
        <Route
          path="/daftar-partner"
          element={
            <WithSidebar component={<PartnerList />} path={"/daftar-partner"} />
          }
        />
        <Route
          path="/daftar-staf"
          element={
            <WithSidebar component={<StaffList />} path={"/daftar-staf"} />
          }
        />
        <Route
          path="/daftar-bank"
          element={
            <WithSidebar component={<BankList />} path={"/daftar-bank"} />
          }
        />
        <Route
          path="/beli-obat"
          element={
            <WithSidebar component={<OtcTransaction />} path={"/beli-obat"} />
          }
        />
        <Route
          path="/beli-obat-rekanan"
          element={
            <WithSidebar
              component={<PartnerOtcTransaction />}
              path={"/beli-obat-rekanan"}
            />
          }
        />
        <Route
          path="/transaksi-tindakan-medis"
          element={
            <WithSidebar
              component={<DoctorTreatmentTransaction />}
              path={"/transaksi-tindakan-medis"}
            />
          }
        />
        <Route
          path="/apotek-penjualan-perhari"
          element={
            <WithSidebar
              component={<PharmacySales />}
              path={"/apotek-penjualan-perhari"}
            />
          }
        />
        <Route
          path="/apotek-penjualan-perbulan"
          element={
            <WithSidebar
              component={<PharmacySalesMonthly />}
              path={"/apotek-penjualan-perbulan"}
            />
          }
        />
        <Route
          path="/apotek-penjualan-pertahun"
          element={
            <WithSidebar
              component={<PharmacySalesYearly />}
              path={"/apotek-penjualan-pertahun"}
            />
          }
        />
        <Route
          path="/distribusi-obat"
          element={
            <WithSidebar
              component={<PharmacyDistribution />}
              path={"/distribusi-obat"}
            />
          }
        />
        <Route
          path="/klinik-penjualan-perhari"
          element={
            <WithSidebar
              component={<ClinicSales />}
              path={"/klinik-penjualan-perhari"}
            />
          }
        />
        <Route
          path="/klinik-penjualan-perbulan"
          element={
            <WithSidebar
              component={<ClinicSalesMonthly />}
              path={"/klinik-penjualan-perbulan"}
            />
          }
        />
        <Route
          path="/klinik-penjualan-pertahun"
          element={
            <WithSidebar
              component={<ClinicSalesYearly />}
              path={"/klinik-penjualan-pertahun"}
            />
          }
        />
        <Route
          path="/invoice-belum-bayar"
          element={
            <WithSidebar
              component={<UnpaidInvoice />}
              path={"/invoice-belum-bayar"}
            />
          }
        />
        <Route
          path="/produk-expired"
          element={
            <WithSidebar
              component={<ExpiredProductInvoice />}
              path={"/produk-expired"}
            />
          }
        />
        <Route
          path="/data-transaksi-tindakan-medis"
          element={
            <WithSidebar
              component={<MedicalTreatmentRecord />}
              path={"/data-transaksi-tindakan-medis"}
            />
          }
        />
        <Route
          path="/apotek-profit"
          element={
            <WithSidebar component={<ProfitReport />} path={"/apotek-profit"} />
          }
        />
        <Route
          path="/klinik-penjualan-perhari-rekanan"
          element={
            <WithSidebar
              component={<ClinicPartnerDaily />}
              path={"/klinik-penjualan-perhari-rekanan"}
            />
          }
        />

        <Route
          path="/klinik-penjualan-perbulan-rekanan"
          element={
            <WithSidebar
              component={<ClinicPartnerMonthly />}
              path={"/klinik-penjualan-perbulan-rekanan"}
            />
          }
        />

        <Route
          path="/klinik-penjualan-pertahun-rekanan"
          element={
            <WithSidebar
              component={<ClinicPartnerYearly />}
              path={"/klinik-penjualan-pertahun-rekanan"}
            />
          }
        />

        <Route
          path="/retur"
          element={<WithSidebar component={<ReturList />} path={"/retur"} />}
        />

        <Route
          path="/klinik-penjualan-rentang-rekanan"
          element={
            <WithSidebar
              component={<ClinicPartnerRanged />}
              path={"/klinik-penjualan-rentang-rekanan"}
            />
          }
        />
        <Route path="/data-pasien/:patientId" element={<PatientRecord />} />
        <Route path="*" element={<Navigate to="/dashboard" replace />} />
      </Routes>
    </BrowserRouter>
  );
}

function WithSidebar({ component, path }) {
  return (
    <div className="container">
      <div className="sidebar-container">
        <TunasSideBar selected={path} />
      </div>
      <div className="content-container">{component}</div>
    </div>
  );
}

export default App;
